export { default as WorkTablesTemplate } from "./WorkTablesTemplate";
export { default as WorkTableTemplate } from "./WorkTableTemplate";
export { default as CreateWorkTableTemplate } from "./CreateWorkTableTemplate";
export { default as MeetingDetailTemplate } from "./MeetingDetailTemplate";
